import React, { useState } from 'react'
import './staff-operate-record.scss'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import StaffOperateRecordTable, { recordVersionMap } from './staff-operate-record-table/staff-operate-record-table'
import { DatePicker } from 'antd'
import moment from 'moment'
import { shopStore } from '@/store/shop'

const StaffOperateRecord = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('staff-operate-record', e, m)

    const [date, setDate] = useState<string[]>([])

    return (
        <Expaned className={getCls()}>
            <div className={getCls('header')}>
                <div className="time-picker">
                    <DatePicker.RangePicker
                        dateRender={current => (
                            <div
                                className="ant-picker-cell-inner"
                                style={{
                                    borderRadius: '50%',
                                }}
                            >
                                {current.date()}
                            </div>
                        )}
                        disabledDate={current => {
                            return (
                                current > moment().endOf('day') ||
                                current <
                                    moment().subtract(recordVersionMap[`${shopStore.cashierVersion}`], 'd').endOf('day')
                            )
                        }}
                        onChange={(monent, dateString) => {
                            setDate(dateString[0] ? dateString : [])
                        }}
                        suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                    />
                </div>
            </div>
            <Expaned data-row className={getCls('content')}>
                <StaffOperateRecordTable date={date} />
            </Expaned>
        </Expaned>
    )
}

export default StaffOperateRecord
